var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlowingMapHiphop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter0_f_2637_3143)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 17,
    fill: "#5452FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2637_3143)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_2637_3143",
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 40,
    width: 34,
    height: 34,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 40,
    y: 40,
    width: 34,
    height: 34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 56.9915C73 56.3309 69.6543 55.7549 64.7247 55.4584C69.1715 53.2901 72.0344 51.486 71.7803 50.8761C71.5262 50.2663 68.2144 51.0116 63.5389 52.6294C66.8168 48.928 68.7734 46.1583 68.3076 45.684C67.8417 45.2181 65.072 47.1747 61.3706 50.4526C62.9799 45.7771 63.7337 42.4738 63.1154 42.2197C62.5056 41.9656 60.693 44.837 58.5246 49.2837C58.2282 44.3457 57.6522 41 56.9915 41C56.3309 41 55.7549 44.3457 55.4584 49.2753C53.2901 44.8285 51.486 41.9656 50.8761 42.2197C50.2663 42.4738 51.0116 45.7856 52.621 50.4526C48.9195 47.1747 46.1498 45.2181 45.684 45.684C45.2181 46.1498 47.1747 48.9195 50.4526 52.621C45.7771 51.0116 42.4738 50.2578 42.2197 50.8761C41.9656 51.486 44.837 53.2986 49.2753 55.4584C44.3372 55.7549 41 56.3309 41 56.9915C41 57.6522 44.3457 58.2282 49.2837 58.5246C44.837 60.693 41.9656 62.5056 42.2197 63.1154C42.4738 63.7253 45.7771 62.9799 50.4526 61.3706C47.1747 65.072 45.2181 67.8417 45.684 68.3076C46.1498 68.7734 48.9195 66.8168 52.6294 63.5389C51.0201 68.2144 50.2663 71.5262 50.8761 71.7803C51.486 72.0344 53.2986 69.1631 55.4584 64.7247C55.7549 69.6628 56.3309 73 56.9915 73C57.6522 73 58.2282 69.6543 58.5246 64.7247C60.693 69.1715 62.4971 72.0429 63.1154 71.7888C63.7253 71.5347 62.9799 68.2229 61.3706 63.5558C65.072 66.8338 67.8417 68.7904 68.3076 68.3245C68.7734 67.8587 66.8168 65.0889 63.5389 61.3875C68.2144 62.9968 71.5177 63.7507 71.7718 63.1323C72.0259 62.5225 69.1546 60.7099 64.7078 58.5416C69.6543 58.2282 73 57.6522 73 56.9915Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73 56.9915C73 56.3309 69.6543 55.7549 64.7247 55.4584C69.1715 53.2901 72.0344 51.486 71.7803 50.8761C71.5262 50.2663 68.2144 51.0116 63.5389 52.6294C66.8168 48.928 68.7734 46.1583 68.3076 45.684C67.8417 45.2181 65.072 47.1747 61.3706 50.4526C62.9799 45.7771 63.7337 42.4738 63.1154 42.2197C62.5056 41.9656 60.693 44.837 58.5246 49.2837C58.2282 44.3457 57.6522 41 56.9915 41C56.3309 41 55.7549 44.3457 55.4584 49.2753C53.2901 44.8285 51.486 41.9656 50.8761 42.2197C50.2663 42.4738 51.0116 45.7856 52.621 50.4526C48.9195 47.1747 46.1498 45.2181 45.684 45.684C45.2181 46.1498 47.1747 48.9195 50.4526 52.621C45.7771 51.0116 42.4738 50.2578 42.2197 50.8761C41.9656 51.486 44.837 53.2986 49.2753 55.4584C44.3372 55.7549 41 56.3309 41 56.9915C41 57.6522 44.3457 58.2282 49.2837 58.5246C44.837 60.693 41.9656 62.5056 42.2197 63.1154C42.4738 63.7253 45.7771 62.9799 50.4526 61.3706C47.1747 65.072 45.2181 67.8417 45.684 68.3076C46.1498 68.7734 48.9195 66.8168 52.6294 63.5389C51.0201 68.2144 50.2663 71.5262 50.8761 71.7803C51.486 72.0344 53.2986 69.1631 55.4584 64.7247C55.7549 69.6628 56.3309 73 56.9915 73C57.6522 73 58.2282 69.6543 58.5246 64.7247C60.693 69.1715 62.4971 72.0429 63.1154 71.7888C63.7253 71.5347 62.9799 68.2229 61.3706 63.5558C65.072 66.8338 67.8417 68.7904 68.3076 68.3245C68.7734 67.8587 66.8168 65.0889 63.5389 61.3875C68.2144 62.9968 71.5177 63.7507 71.7718 63.1323C72.0259 62.5225 69.1546 60.7099 64.7078 58.5416C69.6543 58.2282 73 57.6522 73 56.9915Z",
    fill: "#5452FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 56.9915C73 56.3309 69.6543 55.7549 64.7247 55.4584C69.1715 53.2901 72.0344 51.486 71.7803 50.8761C71.5262 50.2663 68.2144 51.0116 63.5389 52.6294C66.8168 48.928 68.7734 46.1583 68.3076 45.684C67.8417 45.2181 65.072 47.1747 61.3706 50.4526C62.9799 45.7771 63.7337 42.4738 63.1154 42.2197C62.5056 41.9656 60.693 44.837 58.5246 49.2837C58.2282 44.3457 57.6522 41 56.9915 41C56.3309 41 55.7549 44.3457 55.4584 49.2753C53.2901 44.8285 51.486 41.9656 50.8761 42.2197C50.2663 42.4738 51.0116 45.7856 52.621 50.4526C48.9195 47.1747 46.1498 45.2181 45.684 45.684C45.2181 46.1498 47.1747 48.9195 50.4526 52.621C45.7771 51.0116 42.4738 50.2578 42.2197 50.8761C41.9656 51.486 44.837 53.2986 49.2753 55.4584C44.3372 55.7549 41 56.3309 41 56.9915C41 57.6522 44.3457 58.2282 49.2837 58.5246C44.837 60.693 41.9656 62.5056 42.2197 63.1154C42.4738 63.7253 45.7771 62.9799 50.4526 61.3706C47.1747 65.072 45.2181 67.8417 45.684 68.3076C46.1498 68.7734 48.9195 66.8168 52.6294 63.5389C51.0201 68.2144 50.2663 71.5262 50.8761 71.7803C51.486 72.0344 53.2986 69.1631 55.4584 64.7247C55.7549 69.6628 56.3309 73 56.9915 73C57.6522 73 58.2282 69.6543 58.5246 64.7247C60.693 69.1715 62.4971 72.0429 63.1154 71.7888C63.7253 71.5347 62.9799 68.2229 61.3706 63.5558C65.072 66.8338 67.8417 68.7904 68.3076 68.3245C68.7734 67.8587 66.8168 65.0889 63.5389 61.3875C68.2144 62.9968 71.5177 63.7507 71.7718 63.1323C72.0259 62.5225 69.1546 60.7099 64.7078 58.5416C69.6543 58.2282 73 57.6522 73 56.9915Z",
    stroke: "#232323",
    strokeWidth: 2,
    mask: "url(#path-2-outside-1_2637_3143)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2637_3143",
    x: 0,
    y: 0,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_2637_3143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2637_3143",
    x: 36,
    y: 40,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2637_3143"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2637_3143",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlowingMapHiphop);
export default __webpack_public_path__ + "static/media/glowing_map_hiphop.26d1e0affa6858820da7f0c1b9e25708.svg";
export { ForwardRef as ReactComponent };